module.exports = __webpack_public_path__ + "static/media/img1-2.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/B/img1-2.png
// module id = 1629
// module chunks = 3